import React from "react";

const Overview = () => {
  return (
    <div className="w-full md:w-[60%] my-5">
      <h1 className="text-3xl font-medium text-blackie">Alpha Enterprises</h1>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 my-6">
        <div>
          <h3 className="text-blackie text-xl font-medium mb-2">
            Business Website
          </h3>
          <p className="text-lightBlackText text-base">alphaenterprises.com</p>
        </div>
        <div>
          <h3 className="text-blackie text-xl font-medium mb-2">
            Phone Number
          </h3>
          <p className="text-lightBlackText text-base">+1 30 4837 767</p>
        </div>
        <div>
          <h3 className="text-blackie text-xl font-medium mb-2">Email</h3>
          <p className="text-lightBlackText text-base">info@alpha.tech</p>
        </div>
      </div>
      <div>
        <h2 className="text-2xl font-semibold text-blackie mb-6">Mission</h2>
        <div>
          <h3 className="text-blackie text-xl font-medium mb-2">Mission</h3>
          <p className="text-lightBlackText text-base">
            Ultricies arcu venenatis in lorem faucibus lobortis at. East odio
            varius nisl congue aliquam nunc est sit pull convallis magna. Est
            scelerisque dignissim non non nibh....
          </p>
        </div>
        <div>
          <h3 className="text-blackie text-xl font-medium mb-2 mt-3">About </h3>
          <p className="text-lightBlackText text-base">
            Ultricies arcu venenatis in lorem faucibus lobortis at. East odio
            varius nisl congue aliquam nunc est sit pull convallis magna. Est
            scelerisque dignissim non non nibh....
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 my-6">
          <div className="">
            <h3 className="text-blackie text-xl font-medium mb-2">Industry</h3>
            <p className="text-lightBlackText text-base">
              Science & Technology
            </p>
          </div>
          <div className="">
            <h3 className="text-blackie text-xl font-medium mb-2">Address</h3>
            <p className="text-lightBlackText text-base">
              36 Guild Street London, San Francisco, USA
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
